import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { ModuleId } from '../api/client';
import { useModules } from '../context/ModulesContext';

export default function ModuleRoute({
  moduleId,
  children,
}: {
  moduleId: ModuleId;
  children: ReactNode;
}) {
  const { loading, isModuleEnabled } = useModules();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="rounded-md border border-gray-200 bg-white p-6 text-sm text-gray-500">
        {t('common.loading', 'Loading...')}
      </div>
    );
  }

  if (!isModuleEnabled(moduleId)) {
    return <Navigate to="/documents" replace />;
  }

  return <>{children}</>;
}

